import React, { memo, forwardRef, useEffect, useState} from 'react'
import { ref, getDownloadURL } from 'firebase/storage'
import { storage } from '../../firebase'
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const HomeCarousel =  forwardRef((props, reff) => {
 // const [locationData, setLocationData] = useState([]);

 // useEffect(() => {
    
  //   const getImages = async () => {
  //       console.log(props.locations);
  //       for(var i = 0; i < props.locations.length; i++){
  //         if(props.locations[i].media && 
  //               props.locations[i].media[0] &&
  //               props.locations[i].media[0].url){
  //                 console.log(props.locations[i].media[0].url);
  //             props.locations[i].media[0].url = await getDownloadURL(ref(storage, props.locations[i].media[0].url));
  //             const location = props.locations[i];
  //             setLocationData(locations =>
  //               [...locations, location]
  //             )
  //           }
  //         }
  //       }
  //   getImages();
  // }, [props])

   
  return(
    <Carousel className='bs-carousel' fade>
      {props.locations.map((location => {
        return(<Carousel.Item key={location.id} interval={4000}>
          
            <img
              className='object-fit_cover mw-100'
              src={location.media[0].url}
              style={{minWidth: "50vw"}}
              alt={location.display_name + ' slide image'}
              loading="lazy"
              decoding="async"
              />
         
          <Carousel.Caption>
          
              <h3><Link className='link-cream txt-shadow' to={'/location/'+ location.display_name +'/' + location.id}>{location.display_name}</Link></h3>
              <p><Link className='link-cream txt-shadow' to={'/location/'+ location.display_name +'/' + location.id}>{location.description}</Link></p>
            
          </Carousel.Caption>
        
        </Carousel.Item>)
      }))}
    </Carousel>
)})

export default memo(HomeCarousel);